import React from 'react';
import { Route, Routes } from 'react-router';
import { ReportDetails } from './details/ReportDetails';
import { ReportList } from './list/ReportList';

/**
 * Router that for report related pages.
 */
export const ReportRouter = () => (
    <Routes>
        <Route path='' element={<ReportList />} />
        <Route path='/:id' element={<ReportDetails />} />
    </Routes>
);
